import { FC } from 'react';

export enum SpinnerSize {
  SMALL = 4,
  DEFAULT = 5
}

const Spinner: FC<{
  size?: SpinnerSize;
}> = ({ size = SpinnerSize.DEFAULT }: { size?: SpinnerSize }) => {
  return (
    <>
      <div
        className={`rounded-1/2 w-${size} h-${size} border-2 border-l-transparent animate-spin-600 border-t-primary-100 border-r-primary-100 border-b-primary-100 border-l-primary-600`}
      ></div>
    </>
  );
};

export default Spinner;
